import { gql } from '__generated__';

export default gql(`
  mutation JoinWaitlist($input: JoinWaitlistInput!) {
    joinWaitlist(input: $input)
  }
`);
